import React from 'react';

const DownArrow = () => {
  return (
    <>
      <svg
        width='23'
        height='23'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10 18.25L18.25 11.8333H13.6758L13.6667 1.75H6.33333V11.8333H1.75L10 18.25Z'
          stroke='#D13329'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};

export default DownArrow;
